import { FormControlProps } from '@chakra-ui/react';
import { FormControl } from 'components/UI';

const SettingsFormControl = (props: FormControlProps) => (
  <FormControl flexWrap="wrap" w="full" display="flex" justifyContent="center" alignItems="center" {...props} />
);

export default SettingsFormControl;
